import { createIcon as createChakraIcon } from '@chakra-ui/react';

import type { ICreateIconParams } from './interface';

export function createIcon(
  params: ICreateIconParams,
): ReturnType<typeof createChakraIcon> {
  const icon = createChakraIcon(params);

  return icon;
}
